import { Link } from "react-router-dom";
import { mangaList } from "@/mocks/manga";

const featured = mangaList.find((m) => m.slug === "wuhou-de-chuangbian-mao")!;

const stats = [
  { value: "120+", label: "精选治愈作品", icon: "ri-book-2-fill" },
  { value: "86万+", label: "追更收藏", icon: "ri-heart-3-fill" },
  { value: "9.2", label: "平均评分", icon: "ri-star-fill" },
  { value: "4", label: "萌系频道", icon: "ri-apps-2-fill" },
];

export default function Editorial() {
  return (
    <section className="container-page mt-12 md:mt-16">
      <div className="flex items-end justify-between">
        <div>
          <span className="chip bg-primary-100 text-primary-700">
            <i className="ri-quill-pen-fill mr-1" aria-hidden="true"></i>
            编辑精选
          </span>
          <h2 className="mt-3 text-xl font-bold text-foreground-950 md:text-2xl">本周编辑私心推荐</h2>
        </div>
        <Link to="/manga/wuhou-de-chuangbian-mao" className="hidden items-center gap-1 text-sm font-medium text-primary-700 hover:text-primary-800 sm:flex">
          查看详情 <i className="ri-arrow-right-line" aria-hidden="true"></i>
        </Link>
      </div>

      <div className="mt-6 grid grid-cols-1 gap-5 overflow-hidden rounded-3xl border border-background-200 bg-background-50 lg:grid-cols-2">
        <div className="relative h-64 w-full sm:h-80 lg:h-full">
          <img
            src={featured.cover}
            alt={`${featured.title} 编辑推荐封面`}
            title={`${featured.title} - 喵趣漫画网编辑精选`}
            className="h-full w-full object-cover"
          />
          <span className="absolute left-4 top-4 rounded-full bg-background-50/90 px-3 py-1 text-xs font-bold text-secondary-900 backdrop-blur">
            软萌画风 · 治愈
          </span>
        </div>

        <div className="flex flex-col justify-center p-6 md:p-8">
          <h3 className="text-xl font-bold text-foreground-950 md:text-2xl">{featured.title}</h3>
          <div className="mt-2 flex flex-wrap items-center gap-3 text-sm text-foreground-600">
            <span className="flex items-center gap-1">
              <i className="ri-star-fill text-accent-500" aria-hidden="true"></i>
              {featured.rating.toFixed(1)}
            </span>
            <span>作者 · {featured.author}</span>
            <span className="rounded-full bg-secondary-100 px-2 py-0.5 text-xs text-secondary-900">{featured.status}</span>
          </div>
          <p className="mt-4 text-sm leading-7 text-foreground-700">{featured.summary}</p>
          <p className="mt-3 line-clamp-3 text-sm leading-6 text-foreground-600">{featured.intro[0]}</p>
          <div className="mt-6 flex flex-wrap gap-3">
            <Link to={`/manga/${featured.slug}`} className="btn-primary">
              立即阅读 <i className="ri-play-line ml-1" aria-hidden="true"></i>
            </Link>
            <Link to="/category/yuzhi" className="btn-ghost">
              更多治愈番
            </Link>
          </div>
        </div>
      </div>

      <div className="mt-10 grid grid-cols-2 gap-4 md:grid-cols-4">
        {stats.map((s) => (
          <div key={s.label} className="flex flex-col items-center rounded-2xl border border-background-200 bg-background-50 px-4 py-6 text-center">
            <span className="flex h-11 w-11 items-center justify-center rounded-full bg-accent-100 text-xl text-accent-700">
              <i className={s.icon} aria-hidden="true"></i>
            </span>
            <span className="mt-3 font-heading text-2xl font-bold text-foreground-950">{s.value}</span>
            <span className="mt-1 text-xs text-foreground-500">{s.label}</span>
          </div>
        ))}
      </div>
    </section>
  );
}